import { useMutation } from '@tanstack/react-query';

import { getJwt } from '@jane/shared/auth';

import { janeApi } from '../api/janeApi';

interface MutationProps {
  onError?: () => void;
  onSuccess?: () => void;
}

const updateMedicalIdNumber = async (idNumber: string) =>
  janeApi.patch(
    '/user_medical_id_numbers',
    { user_medical_id_number: { id_number: idNumber } },
    getJwt()
  );

export const useUpdateMedicalIdNumber = ({
  onError,
  onSuccess,
}: MutationProps = {}) =>
  useMutation({
    mutationFn: updateMedicalIdNumber,
    onSuccess,
    onError,
  });

const deleteMedicalIdNumber = async () =>
  janeApi.delete('/user_medical_id_numbers', getJwt());

export const useDeleteMedicalIdNumber = ({
  onError,
  onSuccess,
}: MutationProps = {}) =>
  useMutation({
    mutationFn: deleteMedicalIdNumber,
    onSuccess,
    onError,
  });
